import { render } from "./PainelMemoriaAprovarMensagem.vue?vue&type=template&id=44d7abb4&scoped=true"
import script from "./PainelMemoriaAprovarMensagem.vue?vue&type=script&lang=js"
export * from "./PainelMemoriaAprovarMensagem.vue?vue&type=script&lang=js"

import "./PainelMemoriaAprovarMensagem.vue?vue&type=style&index=0&id=44d7abb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d7abb4"]])

export default __exports__